<template>
  <div class="product-customization">
    <div class="botm-pushed-content">
      <!-- product name and description commented as per design -->
      <!-- <div v-if="clientPlatform != 'Web'" class="sticky-header mb16">
        <div class="d-flex align-items-center pb12 pl16">
          <i class="mr8" :class="[isVeg ? 'tag-veg' : 'tag-non-veg']"></i>
          <span class="fs-16 bold">{{ product?.displayName }}</span>
        </div>
      </div> -->
      <div
        class="bg-white"
        :class="[clientPlatform == 'Web' ? 'flex-row cust-wrap pt16' : '']"
      >
        <div class="lft-mod" v-if="clientPlatform == 'Web'">
          <div>
            <img :src="getImageUrl(product)" class="w312" />
          </div>
          <div class="d-flex align-items-center mt10 ml10">
            <i class="mr8 tag-veg"></i>
            <span class="product-title bold fs-14">{{
              product?.displayName
            }}</span>
          </div>
          <div class="long-desc pl16 fs-12 color-slaty lh16">
            {{ product?.description }}
          </div>
        </div>
        <!-- product customizations -->
        <div class="rgt-mod scroll-custom">
          <div v-if="!product.comboUID">
            <!-- choose size among crust -->
            <div
              class="crustwise-size-list pb24"
              :class="[clientPlatform == 'Web' ? '' : 'plr16']"
            >
              <h3 class="fs-16 bold">
                {{ product?.variants?.[0].attributes?.[0]?.description }}
              </h3>
              <div
                class="fs-11 color-slaty"
                v-if="product?.variants?.length > 1"
              >
                Select any 1 out of {{ product?.variants?.length }}
              </div>
              <!-- Radio type options ui -->
              <div class="mt12">
                <!-- use disabled class for disabling -->
                <!-- repeat label for more options -->
                <div v-if="!product.comboUID">
                  <CustomLabelRadio
                    v-for="(item, index) in customizationOptions"
                    :key="index"
                    :label="item.name"
                    :customIndex="'select-beverage-0'"
                    :itemPrice="item?.price?.currentPrice"
                    :regularPrice="item?.price?.regularPrice"
                    :value="index"
                    :checkboxName="
                      product?.variants?.[0].attributes?.[0]?.description ||
                      product?.variants?.find((x) => x.defaultVariant)
                        ?.attributes?.[0]?.value
                    "
                    :isSelected="
                      checkCartUpsell
                        ? getUpsellDefaultVariant(index)
                        : isOnCartPage
                          ? selectedVariantIndex == index
                          : isSelectedCust(
                              product?.variants?.find((x) => x.defaultVariant)
                                ?.skuId == item.skuId,
                              selectedVariantIndex == index,
                            )
                    "
                    :dietType="getDietType(item)"
                    :isCustomisable="true"
                    :isCombo="false"
                    @radioHandler="radioCallback"
                  />
                </div>
              </div>
            </div>

            <!--             <div class="veg-toppings-list pb24 plr16" v-if="product.comboUID">
              <h3 class="fs-16 bold mb15 disp-col-inline">
                Select your Beverage <i class="ml8 tag-veg"></i>
              </h3>
            </div> -->
          </div>

          <div v-if="product.comboUID">
            <div
              class="crustwise-size-list pb24"
              :class="[clientPlatform == 'Web' ? '' : 'plr16']"
              v-for="(group, index) in customizationOptions"
              :key="index"
            >
              <h3 class="fs-16 bold">
                {{ group.groupName }}
              </h3>
              <div
                class="fs-11 color-slaty"
                v-if="
                  product.comboUID &&
                  group.maxItems == 1 &&
                  group.items.length > 1
                "
              >
                Select any 1 out of {{ group.items.length }}
              </div>
              <div
                class="fs-11 color-slaty"
                v-if="
                  product.comboUID &&
                  group.maxItems > 1 &&
                  group.items.length > 1
                "
              >
                Select up to {{ group.maxItems }} options
              </div>
              <!-- Radio type options ui -->
              <div class="mt12" v-if="group.maxItems <= 1">
                <!-- use disabled class for disabling -->
                <CustomLabelRadio
                  v-for="(item, subIndex) in group.items"
                  :key="subIndex"
                  :label="
                    getVariantNameFromProductID(item) ||
                    item.productDetails?.displayName
                  "
                  :customIndex="group.groupName"
                  :itemPrice="
                    getPrice(
                      item.products[0]?.price?.currentPrice,
                      item?.defaultPrice,
                    )
                  "
                  :regularPrice="
                    getPrice(
                      item.products[0]?.price?.regularPrice,
                      item?.defaultPrice,
                    )
                  "
                  :value="index + '_' + subIndex"
                  :checkboxName="group.groupName"
                  :isSelected="
                    isOnCartPage
                      ? selectedGroupsIndexes[index]?.[subIndex]
                      : isSelectedGroupCust(
                          index,
                          item.default,
                          selectedGroupsIndexes[index]?.[subIndex],
                        )
                  "
                  :class="{
                    disabled:
                      selectedComboInvalidItemsList.includes(
                        item.parentSkuId,
                      ) || isItemDisabled(item),
                  }"
                  :dietType="getDietType(item?.productDetails)"
                  :isCombo="true"
                  @radioHandler="radioCallback"
                />
              </div>

              <!-- Checkbox type options ui -->
              <div class="mt12" v-if="group.maxItems > 1">
                <!-- repeat label for more options -->
                <CustomLabelCheckbox
                  v-for="(item, subIndex) in group.items"
                  :label="
                    getVariantNameFromProductID(item) ||
                    item.productDetails?.displayName
                  "
                  :customIndex="group.groupName"
                  :class="{
                    disabled:
                      (selectedGroupsIndexes[index]?.filter((it) => {
                        return it;
                      }).length >= group.maxItems &&
                        !selectedGroupsIndexes[index]?.[subIndex]) ||
                      selectedComboInvalidItemsList.includes(item.parentSkuId),
                  }"
                  :key="subIndex"
                  :itemPrice="
                    getPrice(
                      item.products[0]?.price?.currentPrice,
                      item?.defaultPrice,
                    )
                  "
                  :regularPrice="
                    getPrice(
                      item.products[0]?.price?.regularPrice,
                      item?.defaultPrice,
                    )
                  "
                  :value="index + '_' + subIndex"
                  :checkboxName="group.groupName"
                  :isSelected="
                    isOnCartPage
                      ? selectedGroupsIndexes[index]?.[subIndex]
                      : isSelectedGroupCust(
                          index,
                          item.default,
                          selectedGroupsIndexes[index]?.[subIndex],
                        )
                  "
                  :dietType="getDietType(item?.productDetails)"
                  @checkboxHandler="checkboxCallback"
                />
              </div>
            </div>
          </div>

          <div
            v-for="(upsell, index) in product?.variants?.find(
              (x) => x.defaultVariant,
            )?.upSell"
            :key="index"
          >
            <div
              class="upsell-list-wrap ml16 mr16"
              v-if="
                upsell?.items?.length &&
                getCategorisedUpSellItems(upsell?.items)?.length
              "
            >
              <div class="fs-16 bold color-slaty mb2">
                {{ upsell?.groupName }}
              </div>
              <div class="fs-12 color-slaty mb12">
                Select upto {{ upsell?.items?.length }}
                {{ upsell?.items?.length > 1 ? "options" : "option" }}
              </div>

              <div class="mt12 mb12">
                <CustomLabelCheckbox
                  v-for="(item, key, index) in getCategorisedUpSellItems(
                    upsell?.items,
                  )"
                  :label="item?.displayName"
                  :customIndex="'select-beverage-1'"
                  :key="index"
                  :itemPrice="item?.selectedVariant?.price?.currentPrice"
                  :regularPrice="item?.selectedVariant?.price?.regularPrice"
                  :value="key"
                  :checkboxName="'abc'"
                  :isSelected="false"
                  :dietType="
                    item?.productDetails
                      ? getDietType(item?.productDetails)
                      : item?.isVeg
                        ? 'veg'
                        : 'non-veg'
                  "
                  @checkboxHandler="checkboxCallbackUpSell"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- bottom fixed -->
      <div class="customised-details">
        <div
          class="btn bold custm-cta secondary"
          @click="addtocart({})"
          :class="{
            disabled: shouldAddToCartBeDisabled,
          }"
          v-if="!isOnCartPage"
          v-ripple
        >
          <span
            >Add <i class="rs">Rs.</i
            >{{ parseFloat(totalPrice.toFixed(2)) }}</span
          >
        </div>
        <div
          class="btn bold custm-cta secondary"
          @click="updateCart({})"
          :class="{
            disabled: shouldAddToCartBeDisabled,
          }"
          v-else
          v-ripple
        >
          <span
            >Update <i class="rs">Rs.</i
            >{{ parseFloat(totalPrice.toFixed(2)) }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLabelRadio from "./CustomLabelRadio.vue";
import CustomLabelCheckbox from "./CustomLabelCheckbox.vue";
import Utility from "../helpers/utility";
import { clientPlatform, staticImgBaseUrl } from "../config/apiEndpoints";
import {
  keyMapsMutation,
  keyMapsGetter,
  keyMapsAction,
} from "../helpers/storeKeys";
import {
  EVENT_CLICK_UPSELL_ITEM,
  EVENT_IMPRESSION_UPSELL_ITEM,
  EVENT_IMPRESSION_CUSTOMIZATION,
  EVENT_CLICK_CUSTOMIZATION_COMBO,
  EVENT_ITEM_CUSTOMISE_SHOWN,
  EVENT_ITEM_CUSTOMISE_OPTION_SELECTED,
  EVENT_CUSTOMIZE_SCREEN,
  EVENT_CUSTOMIZED_PRODUCT,
} from "../helpers/analyticsEvents";
import { DISABLED_ORDER_TYPE } from "../helpers/OrderStatusConstants";
import LocalStorageFunc from "../helpers/localStorageFunc";

export default {
  name: "ProductCustomization",
  props: [],
  components: {
    CustomLabelRadio,
    CustomLabelCheckbox,
  },
  data() {
    return {
      selectedUpSellItems: {},
      clientPlatform,
      staticImgBaseUrl: staticImgBaseUrl,
      impressionProcessed: false,
      isVeg: true,
      isVegItemsList: { 0: true, 1: true },
      selectionTriggered: false,
      groupSelectionTriggered: [],
    };
  },
  mounted() {
    EVENT_ITEM_CUSTOMISE_SHOWN({
      cartId: LocalStorageFunc.cartId(),
      cartTotal: this.cartTotal,
    });
    EVENT_CUSTOMIZE_SCREEN({
      category: this.$store?.state?.ProductItems?.productCounterString,
    });
    if (this.$store?.state?.ProductItems?.showCustomisableFor) {
      EVENT_IMPRESSION_CUSTOMIZATION();
    }
    if (this.product?.groups) {
      this.product?.groups.map((group, index) => {
        this.groupSelectionTriggered[index] = false;
      });
    }
  },
  methods: {
    getVariantNameFromProductID(item) {
      return item?.productDetails?.variants.length > 1
        ? `${item?.productDetails?.displayName} - ${
            item?.productDetails?.variants.filter(
              (variant) => variant.productUID == item.products[0]?.productID,
            )?.[0].displayName
          }`
        : item?.productDetails?.variants.filter(
            (variant) => variant.productUID == item.products[0]?.productID,
          )?.[0].displayName;
    },
    comboProductSelectedVariantNames(payload) {
      let name = [];
      payload?.selectedComboVariant?.map((group) => {
        group?.items?.map((_) => {
          let pr = payload.customizationOptions
            .filter((co) => {
              return co?.groupName == group?.groupName;
            })?.[0]
            ?.items.filter((item) => {
              return item?.parentSkuId == _?.parentSkuId;
            })?.[0];

          let displayName = pr?.productDetails?.variants?.filter((variant) => {
            return variant?.productUID == pr?.products[0]?.productID;
          })?.[0]?.displayName;
          if (displayName) {
            name.push(displayName);
          }
        });
      });
      return name.join(", ");
    },
    radioCallback(data) {
      let selectedGroupsIndexes =
        this.$store.state.ProductItems.selectedGroupsIndexes;
      if (this.product?.comboUID) {
        const [index, subIndex] = data.value.split("_");
        this.isVegItemsList[index] = data.isVeg;
        selectedGroupsIndexes[index] = Array(
          selectedGroupsIndexes[index].length,
        ).fill(false);
        selectedGroupsIndexes[index][subIndex] = true;
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_GROUP_INDEXES,
          selectedGroupsIndexes,
        );
        EVENT_ITEM_CUSTOMISE_OPTION_SELECTED({
          cartId: LocalStorageFunc.cartId(),
          cartTotal: this.cartTotal,
          sectionPostion: index + 1,
          positionWithinSection: subIndex + 1,
          subcategory: data.label,
        });
        this.groupSelectionTriggered[index] = true;
      } else {
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_VARIANT_INDEX,
          data.value,
        );
        EVENT_ITEM_CUSTOMISE_OPTION_SELECTED({
          cartId: LocalStorageFunc.cartId(),
          cartTotal: this.cartTotal,
          sectionPostion: 2,
          positionWithinSection: data.value + 1,
          subcategory: data.label,
        });
        this.selectionTriggered = true;
      }
    },
    checkboxCallback(data) {
      let selectedGroupsIndexes =
        this.$store.state.ProductItems.selectedGroupsIndexes;
      if (this.product?.comboUID) {
        const [index, subIndex] = data.value.split("_");
        selectedGroupsIndexes[index][subIndex] = data.checked;
        this.groupSelectionTriggered[index] = true;
      }
      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_GROUP_INDEXES,
        selectedGroupsIndexes,
      );
    },
    checkboxCallbackUpSell(data) {
      if (data.checked) {
        EVENT_CLICK_UPSELL_ITEM({
          upsellProductName: this.getUpSellItems(
            this.product?.variants?.find((x) => x.defaultVariant)?.upSell,
          )?.[data.value]?.selectedVariant?.displayName,
        });
      }

      this.selectedUpSellItems[data.value] = data.checked;
    },
    updateDisableItemToastMsg() {
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, false);
    },
    getDefaultDisplayName(type = "parent") {
      if (type == "parent") {
        return this.customizationOptions
          ?.filter(
            (item) =>
              item?.groupName != "Side" && item?.groupName != "Beverage",
          )[0]
          ?.items?.filter((item) => item?.default)[0]?.productDetails
          ?.displayName;
      } else if (type == "Side") {
        return this.customizationOptions
          ?.filter((item) => item?.groupName == "Side")[0]
          ?.items?.filter((item) => item?.default)[0].productDetails
          ?.displayName;
      } else if (type == "Beverage") {
        return this.customizationOptions
          ?.filter((item) => item?.groupName == "Beverage")[0]
          ?.items?.filter((item) => item?.default)[0].productDetails
          ?.displayName;
      }
    },
    getPreferedDisplayName(type = "parent", selectedGroupsIndexes) {
      if (type == "parent") {
        let groupItem = this.customizationOptions
          ?.map((item, index) => ({ item, index }))
          ?.filter(
            (fItem) =>
              fItem?.item?.groupName != "Side" &&
              fItem?.item?.groupName != "Beverage",
          )[0];
        let selectedIndex = groupItem
          ? selectedGroupsIndexes[groupItem.index].findIndex((item) => item)
          : false;
        return selectedIndex
          ? groupItem?.item?.items[selectedIndex]?.productDetails?.displayName
          : "";
      } else if (type == "Side") {
        let groupItem = this.customizationOptions
          ?.map((item, index) => ({ item, index }))
          .filter((fItem) => fItem?.item?.groupName == "Side")[0];
        let selectedIndex = groupItem
          ? selectedGroupsIndexes[groupItem.index].findIndex((item) => item)
          : false;
        return selectedIndex
          ? groupItem?.item?.items[selectedIndex]?.productDetails?.displayName
          : "";
      } else if (type == "Beverage") {
        let groupItem = this.customizationOptions
          ?.map((item, index) => ({ item, index }))
          .filter((fItem) => fItem.item.groupName == "Beverage")[0];
        let selectedIndex = groupItem
          ? selectedGroupsIndexes[groupItem.index].findIndex((item) => item)
          : false;
        return selectedIndex
          ? groupItem?.item?.items[selectedIndex]?.productDetails?.displayName
          : "";
      }
    },
    addtocart({ variantIndex = this.selectedVariantIndex || 0 }) {
      const upsellItem = this.addUpSellItemsInCart();
      let selectedGroupsIndexes =
        this.$store.state.ProductItems.selectedGroupsIndexes;
      if (this.product?.comboUID) {
        let changedPrice = {
          currentPrice: this.totalPrice,
          regularPrice: this.totalRegularPrice,
        };
        Object.values(this.isVegItemsList).map((x) => {
          if (!x) this.isVeg = false;
        });

        let payload = {
          ...this.product,
          price: changedPrice,
          isVeg: this.isVeg,
          selectedComboVariant: this.product.groups.map((group, index) => {
            return {
              ...group,
              items: [
                ...group.items.filter((item, originalSelectIndex) => {
                  return selectedGroupsIndexes[index][originalSelectIndex];
                }),
              ],
            };
          }),
          customizationOptions: this.customizationOptions,
        };
        this.$store.commit(keyMapsMutation.ADD_TO_CART, payload);
        EVENT_CLICK_CUSTOMIZATION_COMBO({
          customizationOption: this.comboProductSelectedVariantNames(payload),
        });
        EVENT_CUSTOMIZED_PRODUCT({
          productName: this.product?.displayName,
          defaultParentProduct: this.getDefaultDisplayName(),
          defaultSide: this.getDefaultDisplayName("Side"),
          defaultBevrage: this.getDefaultDisplayName("Beverage"),
          preferredParentProduct: this.getPreferedDisplayName(
            "parent",
            selectedGroupsIndexes,
          ),
          preferredBevrage: this.getPreferedDisplayName(
            "Beverage",
            selectedGroupsIndexes,
          ),
          preferredSide: this.getPreferedDisplayName(
            "Side",
            selectedGroupsIndexes,
          ),
          productPrice: this.product?.price?.currentPrice,
          customizedPrice: payload?.price?.currentPrice,
          category: this.$store?.state?.ProductItems?.productCounterString,
        });
        this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
        this.$store.commit(
          keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
          "1 Item added to the cart.",
        );
        setTimeout(this.updateDisableItemToastMsg, 1000);
      } else {
        EVENT_CUSTOMIZED_PRODUCT({
          productName: this.product?.displayName,
          defaultParentProduct: this.customizationOptions?.filter(
            (item) => item.defaultVariant,
          )[0]?.displayName,
          preferredParentProduct:
            this.customizationOptions[variantIndex]?.displayName,
          productPrice:
            this.product?.variants[variantIndex]?.price?.currentPrice || 0,
          customizedPrice: this.totalPrice,
          category: this.$store?.state?.ProductItems?.productCounterString,
          upsellProductName: upsellItem
            ?.map((item) => item?.selectedVariant?.displayName)
            .join(","),
          upsellProductPrice: upsellItem
            ?.map((item) => item?.selectedVariant?.price?.currentPrice)
            .join(","),
        });
        this.$store.commit(keyMapsMutation.ADD_TO_CART, {
          ...this.product,
          selectedVariant: this.product?.variants[variantIndex],
        });
        this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
        this.$store.commit(
          keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
          "1 Item added to the cart.",
        );
        setTimeout(this.updateDisableItemToastMsg, 1000);
      }

      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_CUSTOMISABLE_FOR, "");
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_CUSTOMIZATION_MODAL,
        false,
      );
      if (Utility.isCurrentlyAtUrl("/cart")) {
        this.$store.dispatch(keyMapsAction.CREATE_CART_ITEMS_API, {});
      }
    },
    updateCart() {
      if (this.product?.comboUID) {
        Object.values(this.isVegItemsList).map((x) => {
          if (!x) this.isVeg = false;
        });
        let selectedGroupsIndexes =
          this.$store.state.ProductItems.selectedGroupsIndexes;
        this.$store.commit(keyMapsMutation.UPDATE_ITEM_IN_CART, {
          item: this.selectedItemInCart,
          isVeg: this.isVeg,
          selectedComboVariant: this.product.groups.map((group, index) => {
            return {
              ...group,
              items: [
                ...group.items.filter((item, originalSelectIndex) => {
                  return selectedGroupsIndexes[index][originalSelectIndex];
                }),
              ],
            };
          }),
          customizationOptions: this.customizationOptions,
          quantity: this.selectedItemInCartQuantity,
        });
      } else {
        this.$store.commit(keyMapsMutation.UPDATE_ITEM_IN_CART, {
          item: this.selectedItemInCart,
          selectedVariant: this.product.variants[this.selectedVariantIndex],
          quantity: this.selectedItemInCartQuantity,
        });
      }
      this.$store.commit(keyMapsMutation.UPDATE_SELECTED_ITEM_IN_CART, {});
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_CUSTOMISABLE_FOR, "");
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_CUSTOMIZATION_MODAL,
        false,
      );
      this.$store.dispatch(keyMapsAction.CREATE_CART_ITEMS_API, {});
      document.body.classList.remove("body-stop-scroll-mobile");
    },
    removefromcart(variantIndex) {
      this.$store.commit(keyMapsMutation.REMOVE_FROM_CART, {
        ...this.product,
        selectedVariant: this.product.variants[variantIndex],
      });
      this.$store.commit(
        keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
        "1 Item removed from the cart.",
      );
      setTimeout(this.updateDisableItemToastMsg, 1000);
    },
    upSellItemsTotal() {
      let totalUpsellPrice = 0;
      Object.keys(this.selectedUpSellItems).map((upSellProductUID) => {
        if (this.selectedUpSellItems[upSellProductUID]) {
          totalUpsellPrice +=
            this.getUpSellItems(
              this.product?.variants?.find((x) => x.defaultVariant)?.upSell,
            )[upSellProductUID]?.selectedVariant?.price?.currentPrice || 0;
        }
      });
      return totalUpsellPrice;
    },
    addUpSellItemsInCart() {
      return Object.keys(this.selectedUpSellItems).map((upSellProductUID) => {
        if (this.selectedUpSellItems[upSellProductUID]) {
          const item = this.getUpSellItems(
            this.product?.variants?.find((x) => x.defaultVariant)?.upSell,
          )[upSellProductUID];
          this.$store.commit(keyMapsMutation.ADD_TO_CART, item);
          return item;
        }
      });
    },
    getUpsellDefaultVariant(index) {
      this.radioCallback({ value: index });
      return this.product.variants?.find((x) => x.defaultVariant);
    },
    getPrice(currentPrice, defaultPrice) {
      return parseFloat((currentPrice - defaultPrice).toFixed(2));
    },
    getImageUrl(productItem) {
      let mediaBaseUrl = this.$store.state.ProductItems.imgBaseUrl;
      return Utility.getHomeProductImage(
        productItem,
        mediaBaseUrl,
        staticImgBaseUrl,
      );
    },
    isItemDisabled(item) {
      let deliveryType = LocalStorageFunc.getDeliveryType();
      let isItemDisabled = false;
      item.products[0]?.disabledOrderTypes.map((x) => {
        if (DISABLED_ORDER_TYPE[x] === deliveryType) isItemDisabled = true;
      });
      return isItemDisabled;
    },
    getDietType(item) {
      return Utility.getIsVegFoodType(item) ? "veg" : "non-veg";
    },
    isSelectedCust(itemDefault, customSelection) {
      if (this.selectionTriggered) {
        return customSelection;
      } else return itemDefault;
    },
    isSelectedGroupCust(index, itemDefault, customSelection) {
      if (
        this.groupSelectionTriggered.length &&
        this.groupSelectionTriggered[index]
      ) {
        return customSelection;
      } else return itemDefault;
    },
  },
  computed: {
    product() {
      let showCustomisableFor =
        this.$store.state.ProductItems.showCustomisableFor;
      if (showCustomisableFor) {
        setTimeout(() => {
          typeof searchQueryInputModal === "undefined"
            ? ""
            : searchQueryInputModal.blur();
        }, 0);
      }
      this.isVeg =
        this.$store.state.ProductItems.products[
          Object.keys(
            this.$store.state.ProductItems.productCategoryMap[
              showCustomisableFor
            ],
          )[0]
        ][showCustomisableFor]?.isVeg;
      return this.$store.state.ProductItems.products[
        Object.keys(
          this.$store.state.ProductItems.productCategoryMap[
            showCustomisableFor
          ],
        )[0]
      ][showCustomisableFor];
    },
    customizationOptions() {
      let selectedComboInvalidItemsList =
        this.$store.state.ProductItems.selectedComboInvalidItemsList;
      if (this.isOnCartPage) {
        if (!this.product?.comboUID) {
          let cO = this.product?.variants;
          cO.map((variant, index) => {
            if (
              this.selectedItemInCart?.selectedVariant?.skuId == variant.skuId
            ) {
              this.$store.commit(
                keyMapsMutation.UPDATE_SELECTED_VARIANT_INDEX,
                index,
              );
            }
          });
          return cO;
        } else {
          let defaultPrice = 0;
          let cO = this.product?.groups.map((group) => {
            group.items.map((item) => {
              if (item.default) {
                defaultPrice = item.products[0]?.price?.currentPrice;
              }
            });
            return {
              ...group,
              items: group.items.map((item) => {
                return {
                  ...item,
                  defaultPrice: defaultPrice,
                  productDetails:
                    this.$store.state.ProductItems.products[
                      Object.keys(
                        this.$store.state.ProductItems.productCategoryMap[
                          item.parentSkuId
                        ] || {},
                      )?.[0]
                    ]?.[item.parentSkuId],
                };
              }),
            };
          });
          let selectedComboVariants =
            this.selectedItemInCart?.selectedComboVariant;

          let selectedGroupsIndexes = Array(cO.length).fill(0);

          cO.map((variant, index) => {
            selectedGroupsIndexes[index] = Array(variant.items.length).fill(
              false,
            );
            variant?.items?.map((item, subIndex) => {
              if (
                selectedComboVariants[index].items.find(
                  (i) => i.parentSkuId == item.parentSkuId,
                ) &&
                !selectedComboInvalidItemsList.includes(item.parentSkuId)
              ) {
                selectedGroupsIndexes[index][subIndex] = true;
              }
            });
          });
          this.$store.commit(
            keyMapsMutation.UPDATE_SELECTED_GROUP_INDEXES,
            selectedGroupsIndexes,
          );
          return cO;
        }
      } else {
        if (!this.product?.comboUID) {
          let cO = this.product?.variants;

          cO.map((variant, index) => {
            if (
              this.product?.variants?.find((x) => x.defaultVariant)?.skuId ==
              variant.skuId
            ) {
              this.$store.commit(
                keyMapsMutation.UPDATE_SELECTED_VARIANT_INDEX,
                index,
              );
            }
          });

          return cO;
        } else {
          let defaultPrice = 0;
          let cO = this.product?.groups.map((group) => {
            group.items.map((item) => {
              if (item.default) {
                defaultPrice = item.products[0]?.price?.currentPrice;
              }
            });
            return {
              ...group,
              items: group.items.map((item) => {
                return {
                  ...item,
                  defaultPrice: defaultPrice,
                  productDetails:
                    this.$store.state.ProductItems.products[
                      Object.keys(
                        this.$store.state.ProductItems.productCategoryMap[
                          item.parentSkuId
                        ] || {},
                      )?.[0]
                    ]?.[item.parentSkuId],
                };
              }),
            };
          });

          let selectedGroupsIndexes = Array(cO.length).fill(0);

          cO.map((variant, index) => {
            selectedGroupsIndexes[index] = Array(variant.items.length).fill(
              false,
            );
            variant?.items?.map((item, subIndex) => {
              if (item.default) {
                selectedGroupsIndexes[index][subIndex] = true;
              }
            });
          });
          this.$store.commit(
            keyMapsMutation.UPDATE_SELECTED_GROUP_INDEXES,
            selectedGroupsIndexes,
          );
          return cO;
        }
      }
    },
    totalPrice() {
      let selectedGroupsIndexes =
        this.$store.state.ProductItems.selectedGroupsIndexes;
      let total = 0;
      if (this.product?.comboUID) {
        this.customizationOptions.map((customizationOption, index) => {
          selectedGroupsIndexes[index].map((selectedGroupsIndex, subIndex) => {
            if (selectedGroupsIndex) {
              total +=
                customizationOption?.items[subIndex]?.products[0]?.price
                  ?.currentPrice || 0;
            }
          });
        });
      } else {
        total =
          this.product?.variants[this.selectedVariantIndex]?.price
            ?.currentPrice || 0;
      }
      return total + this.upSellItemsTotal();
    },
    totalRegularPrice() {
      let selectedGroupsIndexes =
        this.$store.state.ProductItems.selectedGroupsIndexes;
      let total = 0;
      if (this.product?.comboUID) {
        this.customizationOptions.map((customizationOption, index) => {
          selectedGroupsIndexes[index].map((selectedGroupsIndex, subIndex) => {
            if (selectedGroupsIndex) {
              let itemPrice =
                customizationOption?.items[subIndex]?.products[0]?.price;
              total += itemPrice?.regularPrice || itemPrice?.currentPrice || 0;
            }
          });
        });
      } else {
        let variantPrice =
          this.product?.variants[this.selectedVariantIndex]?.price;
        total = variantPrice?.regularPrice || variantPrice?.currentPrice || 0;
      }
      return total;
    },
    shouldAddToCartBeDisabled() {
      if (!this.product?.comboUID) {
        return false;
      }
      let selectedGroupsIndexes =
        this.$store.state.ProductItems.selectedGroupsIndexes;
      let flag = false;
      selectedGroupsIndexes?.map((selectedGroupsIndex, index) => {
        let [minItems, maxItems] = [
          this.product?.groups[index]?.minItems,
          this.product?.groups[index]?.maxItems,
        ];
        let selectedItemsCount = selectedGroupsIndexes[index].filter((item) => {
          return item;
        }).length;
        if (selectedItemsCount < minItems) {
          if (!flag) {
            flag = true;
          }
        }
      });
      return flag;
    },
    selectedGroupsIndexes() {
      return this.$store.state.ProductItems.selectedGroupsIndexes;
    },
    getUpSellItems() {
      return (upsell) => {
        let temp =
          this.$store.getters[keyMapsGetter.GET_UPSELL_PRODUCTS](upsell);
        if (Object.keys(temp).length > 0 && !this.impressionProcessed) {
          this.impressionProcessed = true;
          EVENT_IMPRESSION_UPSELL_ITEM();
        }
        return temp;
      };
    },
    getCategorisedUpSellItems() {
      return (upsell) => {
        let temp =
          this.$store.getters[keyMapsGetter.GET_CATEGORISED_UPSELL_PRODUCTS](
            upsell,
          );
        if (Object.keys(temp).length > 0 && !this.impressionProcessed) {
          this.impressionProcessed = true;
          EVENT_IMPRESSION_UPSELL_ITEM();
        }
        return temp;
      };
    },
    isOnCartPage() {
      return Utility.isCurrentlyAtUrl("/cart");
    },
    selectedItemInCart() {
      return this.$store.state.ProductItems.selectedItemInCart;
    },
    selectedComboInvalidItemsList() {
      // @todo use this to disable invalid combo items
      return this.$store.state.ProductItems.selectedComboInvalidItemsList;
    },
    selectedItemInCartQuantity() {
      return this.$store.state.ProductItems.selectedItemInCartQuantity;
    },
    selectedVariantIndex() {
      return this.$store.state.ProductItems.selectedVariantIndex;
    },
    cartTotal() {
      return this.$store.getters[keyMapsGetter.CART_TOTAL];
    },
    checkCartUpsell() {
      let globalUpsellItems = this.$store.state.Cart.globalUpsellItems;
      let cartItems = this.$store.state.Cart.items;
      let found = false;
      globalUpsellItems?.map((item) => {
        if (item?.productMasterUID == this.product?.productMasterUID) {
          found = true;
        }
      });
      return (
        found &&
        !(this.product?.productMasterUID in cartItems) &&
        this.isOnCartPage
      );
    },
  },
};
</script>
